<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>质量监控</el-breadcrumb-item>
			<el-breadcrumb-item>全部监控</el-breadcrumb-item>
		</el-breadcrumb>
		<ToolBar v-on:select="handleSelectJT"></ToolBar>
		<div class="monitor_section" v-if="jtInfo" v-loading="loading">
			<div class="header clearfix">
				<h3>质量监控</h3>
				<!-- <router-link :to="{ name: 'WorkshopView', query: { jt_id: selectedJT._id.$oid } }"> -->
				<el-button style="float: right; padding: 3px 0" type="text" @click="handleFullScreen('defect_view')" > 
					最大化
				</el-button>
				<!-- </router-link> -->
			</div>
			<div id="defect_view" :class="{view:istrue}" >
				
					<el-row  :style="{height:'heightWindous'}"   >
						<el-col :span="12"><device-status id="id" :jt_id="jtInfo._id.$oid"/></el-col>
						<el-col :span="12"> <ColorMonitor  :jt_id="jtInfo._id.$oid" :jt_status="jtInfo.statusInfo"  /> </el-col>
						
					</el-row>
					<el-row >
						<el-col :span="12">
							<div  >
								<h3>最新缺陷记录</h3>								
							</div>
							<div v-show="defects.length == 0 && !loading">
								<span>还没有缺陷记录.</span>
							</div>
							<div class="defection" :style="{height:heightWindous-60+'px'}" >
							<div class="defect_item" v-for="item in defects" :key="item._id.$oid">
					<div class="img_item">
						<img :src="item.img" alt @error="nofindImg()" />
					</div>
					<div class="defectInfo">
						<ul>
							<li>
								<label for>位置：</label>
								<span>{{item.meter|fil}}</span>
							</li>
							<li>
								<label for>检测面：</label>
								<span v-text="item.model_side_text"></span>
							</li>
							<li>
								<label for>缺陷类型：</label>
								<span v-text="item.type_text"></span>
							</li>
							<li>
								<label for>面积：</label>
								<span v-text="item.area"></span>
							</li>
							<li>
								<label for>张号：</label>
								<span v-text="item.sheet_index"></span>
							</li>
							<li>
								<label for>联号：</label>
								<span v-text="item.col"></span>
							</li>
							<li>
								<label for>强度：</label>
								<span v-text="item.energy"></span>
							</li>
						</ul>

					
					</div>
				</div>
							</div>
						</el-col>
						<el-col :span="12"> <VideoMonitor /> </el-col>
					</el-row>
					
				</div>
			
		</div>
	</div>
</template>

<script>
	import maxwindous from './maxWindous.js'
	import ToolBar from './ToolBar'
	import { getDefectRequest, getDefectImageUrlByMd5 } from '../../network/requests/defect'
	import { defectStatisRequest } from '../../network/requests/defectStatis'
	import VideoMonitor from './VideoMonitors.vue'
	import ColorMonitor from './ColorMonitors.vue'
	import DeviceStatus from '../public/DeviceStatus'
	import { defectTypeRequest } from '../../network/requests/defectType'
	import { modelRequest } from '@/network/requests/model'
	import { modelSideRequest } from '@/network/requests/modelSide'

	export default {
		components: {
			ToolBar,
			VideoMonitor,
			ColorMonitor,
			DeviceStatus,
		},
		mixins: [maxwindous],
		data() {
			return {
				demoImage: require('@/assets/images/demo_01.jpg'),
				jtInfo: null,
				defects: [],
				roll_id: '',
				fullscreen: false,
				loading: false,
				timer: null,
			}
		},
		filters:{
			fil(val){
				if (!val) return ''
				const  value =  (val/1000)
				console.log("wnjia",value)
				return `${value}米`
			}
		},
		computed: {	
			heightWindous(){
				return document.body.clientHeight/2
			},		
			
			monitorTime() {
				var value = 5
				var lv = localStorage.getItem('MonitorTime')
				if (lv) {
					value = lv
				}

				return value * 1000
			},
		},
		methods: {
			/**
			 * 查看机台状态。
			 */
			async handleSelectJT(jtInfo) {
				this.jtInfo = jtInfo
				console.log('查看机台', jtInfo)

				this.loading = true

				try {
					//获取最新
					await this.getNewstDefectData()
					//显示缺陷记录。
					await this.bindDefects()
				} catch (error) {
					this.defects = []
					console.error(error)
				} finally {
					this.loading = false
				}

				clearInterval(this.timer)

				this.timer = setInterval(async () => {
					//获取最新
					await this.getNewstDefectData()
					//显示缺陷记录。
					await this.bindDefects()
				}, this.monitorTime)
			},
			async getNewstDefectData() {
				var defectStatis = (
					await defectStatisRequest.queryPage({
						page: 1,
						pagesize: 1,
						filter: { jt_id: this.jtInfo._id.$oid },
						sort: { _id: -1 },
						keys: { _id: 1 },
					})
				).data._embedded

				var defects = []
				if (defectStatis.length > 0) {
					this.roll_id = defectStatis[0]._id.$oid

					//获取最新的10个缺陷记录。
					defects = (
						await getDefectRequest(this.roll_id).queryPage({
							page: 1,
							pagesize: 10,
							filter: undefined,
							sort: { _id: -1 },
						})
					).data._embedded
				}

				this.defects = defects
			},
			async bindDefects() {
				var defectTypes = await defectTypeRequest.queryAll({ roll_id: this.roll_id })
				//获取批次对应的模板。
				var model = (await modelRequest.queryAll({ roll_id: this.roll_id }))[0]
				//获取模板对应的检测面。
				var modelSides = await modelSideRequest.queryAll({ model_id: model._id.$oid })
				if (this.defects.length == 0) return

				console.log('绑定缺陷记录', this.defects)
				var tempArray = []
				for (var item of this.defects) {
					var img = getDefectImageUrlByMd5(item.md5, this.roll_id)

					var type = defectTypes.find(t => t.type_index == item.type_index)
					var ms = modelSides.find(t => t.side_index == item.side_index)
					tempArray.push({ ...item, img, type_text: type.display, model_side_text: ms?.name })
			
				}

				this.defects = tempArray
			},
			nofindImg() {
				const img = event.srcElement
				img.src = require('@/assets/images/img.png')
				img.onerror = null //防止一直跳动
			},
		},
		created() {},
		destroyed() {
			console.log('清除绑定记录。')
			clearInterval(this.timer)
		},
		mounted: {},
	}
</script>

<style scoped>
	.form-table {
		margin-bottom: 20px;
	}

	.defect_item {
		border: 1px #eee solid;
		float: left;
		width: 150px;
		margin-left: 5px;
		margin-right: 5px;
		margin-bottom: 10px;
		/* overflow-y: auto;
		height: 360px; */
	}
	.defect_item:hover {
		background-color: #eee;
	}

	.defectInfo {
		padding: 10px 20px 10px;
	}

	.defectInfo li {
		list-style: none;
		line-height: 20px;
		display: block;
		font-size: 12px;
	}

	.defectInfo li label {
		display: inline-block;
		color: #666;
	}

	.img_item {
		text-align: center;
	}
	.img_item img {
		height: 150px;
	}	
	.defection {
		overflow-y: auto;
		/* height: 500px; */
	}
	
	.view{
		background-color: #fff;padding: 20px;
		
}
</style>
